import { date } from "./app";
import { multiple } from "../utils";

export var event = ev => {
  return new Promise(resolve => {
    var event = {
      title: ev.title,
      all_day: ev.allDay ? 1 : 0,
      url: ev.url ? ev.url : null,
      rendering: ev.rendering ? ev.rendering : null,
      short_description: ev.abstract ? ev.abstract : null,
      long_description: ev.description ? ev.description : null,
      image: ev.image ? ev.image : null
    };
    event.end = null;
    Promise.all([
      ev.start ? date(String(ev.start)) : Promise.resolve(""),
      ev.end ? date(String(ev.end)) : Promise.resolve("")
    ]).then(values => {
      event.start = values[0];
      event.end = values[1];
      resolve(event);
    });
  });
};

export var participation = pt => {
  return new Promise(resolve => {
    resolve(pt);
  });
};

export var participant = pt => {
  return new Promise(resolve => {
    resolve({
      email: pt.email,
      reason: pt.reason,
      notice: pt.notice
    });
  });
};

export var session = sn => {
  var events = [];
  return new Promise(resolve => {
    sn.events.forEach(ev => {
      event(ev).then(res => {
        var item = res;
        item.participations = ev.participations;
        events.push(item);
      });
    });

    resolve({
      description: sn.description ? sn.description : null,
      events: events
    });
  });
};

export var events = list => {
  return multiple(list, event);
};

export var participations = list => {
  return multiple(list, participation);
};

export var participants = list => {
  return multiple(list, participant);
};

export var sessions = list => {
  return multiple(list, session);
};

const adapters = {
  event,
  events,
  participation,
  participations,
  participant,
  participants,
  session,
  sessions
};

export default adapters;
